<template>
    <div>
        <a v-for="attachment in attachments"
           class="block py-1 text-blue text-sm"
           :href="url(attachment)"
           target="_blank"
           :aria-label="`${attachment.title} (opens in new tab)`"
        >
            <i class="fa-solid fa-file mr-1"></i>
            {{ attachment.title }}
        </a>
    </div>
</template>

<script>

export default {
    name: "AttachmentsListShowCondensed",
    props: ['attachments'],
    methods: {
        url(attachment) {
            return Boardable.org_url + "documents/" + attachment.uuid.short_slug;
        }
    }
}

</script>